import { render, staticRenderFns } from "./Add.vue?vue&type=template&id=ba59fe18&scoped=true"
import script from "./Add.vue?vue&type=script&lang=ts"
export * from "./Add.vue?vue&type=script&lang=ts"
import style0 from "./Add.vue?vue&type=style&index=0&id=ba59fe18&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba59fe18",
  null
  
)

export default component.exports